module.exports = __webpack_public_path__ + "img/custom-trex.fc31fe11.jpg";